/**
 * The button around a clickable count: the joined schedule counts on a search
 * card and in the table's Schedules cell.
 *
 * It fades on hover and shows the focus ring on keyboard focus. `relative`
 * holds the badges' hidden labels inside the button. The last class overrides
 * the `cursor-default` that {@link ScheduleBadgePair} sets on its own spans, so
 * the whole count shows a pointer.
 */
export const COUNT_BUTTON_CLASS =
    'relative inline-flex shrink-0 cursor-pointer rounded transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring [&_*]:cursor-pointer';
